/* eslint-disable security/detect-object-injection */
import PendingIcon from '@mui/icons-material/Pending'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import StopIcon from '@mui/icons-material/Stop'
import { Chip } from '@mui/material'
import { FC } from 'react'
import { useTranslate } from 'react-admin'

type StatuseType = 'INITIALISATIE' | 'OPEN' | 'GESLOTEN'

interface AccessPrivilegeChipProps {
  status: string | null | undefined
}

const SamenwerkingStatusChip: FC<AccessPrivilegeChipProps> = ({ status }) => {
  const translate = useTranslate()

  const validStatuses: StatuseType[] = ['INITIALISATIE', 'OPEN', 'GESLOTEN']

  if (!status || !validStatuses.includes(status as StatuseType)) {
    return <span />
  }

  const colorMap: Record<StatuseType, 'success' | 'info' | undefined> = {
    INITIALISATIE: 'info',
    OPEN: 'success',
    GESLOTEN: undefined,
  }

  const iconMap: Record<StatuseType, JSX.Element> = {
    INITIALISATIE: <PendingIcon fontSize="small" />,
    OPEN: <PlayArrowIcon fontSize="small" />,
    GESLOTEN: <StopIcon fontSize="small" />,
  }

  if (!status) {
    return <span />
  }

  return (
    <Chip
      label={translate(`resources.collaborations.status.${status}`)}
      color={colorMap[status as StatuseType]}
      icon={iconMap[status as StatuseType]}
      variant="outlined"
      size="small"
    />
  )
}

export default SamenwerkingStatusChip